import React, { useEffect, useRef } from 'react';
import "./styles.less"

interface MapCarouselProps {
    items: React.ReactNode[];
    visibleItems?: number;
    itemHeight?: number;
    onEndReached: () => void;
}

export const MapCarousel = ({
    items,
    itemHeight = 175,
    onEndReached
}: MapCarouselProps) => {
  const carouselRef = useRef(null);
  const tolerance = 20;

  const handleScroll = () => {
    const carousel = carouselRef.current;

    if (carousel.scrollTop + carousel.clientHeight >= carousel.scrollHeight - tolerance) {
      onEndReached();
    }
  };

  useEffect(() => {
      const carousel = carouselRef.current;
      carousel.addEventListener("scroll", handleScroll);

      return () => {
          carousel.removeEventListener("scroll", handleScroll);
      };
  }, [carouselRef]);

  return (
      <div
        className="carousel-container"
        style={{
          height: "100%",
        }}
        ref={carouselRef}
      >
        <div
          className="carousel-track"
        >
          {items.map((item, index) => (
            <div
              key={index}
              className="carousel-item"
              // min-height y no height: la card crece si el contenido no entra
              // (precio en dos lineas, label "Unidades desde:", fila de CTAs)
              style={{ minHeight: `${itemHeight}px` }}
            >
              {item}
            </div>
          ))}
        </div>
      </div>
  );
}